import { render } from "./LohnastusedView.vue?vue&type=template&id=44bb56d0"
import script from "./LohnastusedView.vue?vue&type=script&lang=js"
export * from "./LohnastusedView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__